import { render } from "./KdnView.vue?vue&type=template&id=7c5b189b&scoped=true"
import script from "./KdnView.vue?vue&type=script&lang=js"
export * from "./KdnView.vue?vue&type=script&lang=js"

import "./KdnView.vue?vue&type=style&index=0&id=7c5b189b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5b189b"]])

export default __exports__